<template>
    <v-stepper v-model="step" alt-labels non-linear>
        <v-stepper-header>
            <!-- Step 1 -->
            <v-stepper-step :color="kingsGreen" :complete="step > 1" step="1">
                Release of Information - Residence
            </v-stepper-step>
            <v-divider></v-divider>

            <!-- Step 2 -->
            <v-stepper-step :color="kingsGreen" :complete="step > 2" step="2">
                Release Of Information Detail - Authorized Individual(s)
            </v-stepper-step>
            <v-divider></v-divider>

            <!-- Step 3 -->
            <v-stepper-step :color="kingsGreen" :complete="step > 3" step="3">
                Review & Submit
            </v-stepper-step>
            <v-divider></v-divider>

            <!-- Step 4 -->
            <v-stepper-step :color="kingsGreen" :complete="submission" step="4">
                Submission
            </v-stepper-step>
        </v-stepper-header>
        <!-- Step 1 -->
        <v-stepper-content step="1">
            <release-of-information-contact :address="address" :cn="cn" :username="username" @setAddress="setAddress"
                @setStep="setStep" @scrollToTop="scrollToTop">
            </release-of-information-contact>
        </v-stepper-content>

        <!-- Step 2 -->
        <v-stepper-content step="2">
            <release-of-information-detail :contacts="contacts" :panels="panels" @addPanel="addPanel" @addUser="addUser"
                @removePanel="removePanel" @removeUser="removeUser" @resetPanel="resetPanel" @setStep="setStep"
                @scrollToTop="scrollToTop">
            </release-of-information-detail>
        </v-stepper-content>

        <!-- Step 3 -->
        <v-stepper-content step="3">
            <release-of-information-review :address="address" :cn="cn" :submitBool="submitBool" :username="username"
                :contacts="contacts" @setStep="setStep" @submitForm="submitForm" @scrollToTop="scrollToTop">
            </release-of-information-review>
        </v-stepper-content>

        <!-- Step 4 -->
        <v-stepper-content step="4">
            <release-of-information-submission @setStep="setStep" @scrollToTop="scrollToTop">
            </release-of-information-submission>
        </v-stepper-content>
    </v-stepper>
</template>

<script>
import auth from '../../../js/auth';
import ReleaseOfInformationContact from './Contact';
import ReleaseOfInformationDetail from './Detail';
import ReleaseOfInformationReview from './Review';
import ReleaseOfInformationSubmission from './Submission';

export default {
    name: 'release-of-information-form',
    components: {
        ReleaseOfInformationContact,
        ReleaseOfInformationDetail,
        ReleaseOfInformationReview,
        ReleaseOfInformationSubmission
    },
    data() {
        return {
            address: '',
            cn: '',
            contacts: [],
            panels: [],
            step: 1,
            submitBool: false,
            submission: false,
            username: ''
        }
    },
    methods: {
        addUser() {
            this.contacts.push({
                accessCode: '',
                accessMethod: [],
                accessResidenceInformation: [],
                endDate: '',
                endDateMenu: false,
                emergencyContact: '0',
                mail: '',
                name: '',
                relationship: '',
                relationshipDetail: '',
                startDate: '',
                startDateMenu: false,
                phone: ''
            });

            this.$emit('setNotification', '#1dc9b7', 'mdi-account-check', `An authorized user has been successfully added.`, true);
        },
        addPanel() {
            this.panels.push(this.contacts.length);
        },
        getFormData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getROI`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (!json.result.match(/OK/i)) {
                        this.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `Release of Information Form data could not be retrieved. Please contact your system administrator.`, true);
                    } else {
                        // Set address
                        if (json.data && json.data.address) {
                            that.address = json.data.address;
                        }

                        // Set contacts
                        if (json.data && json.data.contacts) {
                            for (let i = 0; i < json.data.contacts.length; i++) {
                                json.data.contacts[i].endDateMenu = false;
                                json.data.contacts[i].startDateMenu = false;
                                that.panels.push(i);
                            }

                            that.contacts = json.data.contacts;
                        }
                    }

                    that.$emit('setLoader', false);
                })
                .catch(function () {
                    that.$emit('setLoader', false);
                })
        },
        removePanel() {
            this.panels.pop();
        },
        removeUser(i) {
            this.contacts.splice(i, 1);
        },
        resetPanel() {
            this.panels = [];
        },
        resolveUser() {
            let user = auth.getUser();

            this.cn = user.commonName;
            this.username = user.username;
        },
        setAddress(val) {
            this.address = val;
        },
        setStep(val) {
            this.step = val;
        },
        scrollToTop() {
            this.$vuetify.goTo(1, {
                duration: 200,
                offset: 0,
                easing: "easeInOutCubic"
            });
        },
        submitForm() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?setROI`;
            let user = {
                address: this.address,
                cn: this.cn,
                contacts: this.contacts,
                username: this.username
            };

            this.submitBool = true;

            // Strip out fields
            for (let i = 0; i < user.contacts.length; i++) {
                delete user.contacts[i].endDateMenu;
                delete user.contacts[i].startDateMenu;
            }

            // Parse array into string
            formData.append('mode', 'setROI');
            formData.append('user', JSON.stringify(user));

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-send-check', `The Release of Information Form has been successfully submitted.`, true);
                        that.submission = true;
                        that.setStep(4);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `The Release of Information Form could not be submitted. Please contact your system administrator.`, true);
                    }

                    that.submitBool = false;
                })
                .catch(function () {
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGreen() {
            return '#004236';
        },
        successColor() {
            return '#1bc5bd';
        }
    },
    created() {
        this.getFormData();
        this.resolveUser();
    },
}
</script>